// 星期
export const weekDay = {
  0: '星期天',
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六'
}
// 审批状态
export const checkState = {
  1: {
    label: '待发起',
    color: '#999999'
  },
  2: {
    label: '审批中',
    color: '#E2803D'
  },
  3: {
    label: '驳回',
    color: '#D35E5E'
  },
  4: {
    label: '通过',
    color: '#60C96D'
  },
  null: {
    label: ''
  }
}

// 审批节点   1 未处理 2 已通过 3 已驳回   李雪说的审批状态
export const checkStateEx = {
  1: {
    label: '未处理',
    color: '#999999'
  },
  2: {
    label: '已通过',
    color: '#60C96D'
  },
  3: {
    label: '已驳回',
    color: '#D35E5E'
  },
  null: {
    label: ''
  }
}

// 合同状态
export const compartState = {
  0: '未签',
  1: '待审核',
  2: '审核中',
  3: '待签署',
  4: '履行中',
  5: '已履行',
  6: '已作废',
  7: '审核不通过',
  8: '盖章审核'
}

// 销售合同备货状态 1备货审核;2待配货;3配货中;4备货中;5已备货;6审核不通过
export const releaseStatus = {
  0: '未备货',
  1: '备货审核',
  2: '待配货',
  3: '配货中',
  4: '备货中',
  5: '已备货',
  6: '审核不通过'
}

// 销售合同付款类型 1 - 约定账期;2-全款发货;3-先货后款;4-期货期款
export const payTypeStatus = {
  1: '约定账期',
  2: '全款发货',
  3: '先货后款',
  4: '期货期款'
}

// 销售合同交货设置 1- 现货现发,期货到货后发货 2 整单到期发货
export const deliverySettingStatus = {
  1: '现货现发,期货到货后发货',
  2: '整单到期发货'
}

// 审批询价状态
export const cbPriceSourceStatus = {
  1: '系统',
  2: '人工',
  3: '特价审批',
  4: '其他',
  5: '库存'

}

// 产品发货状态 0 未发货 1 已发货
export const deliverStateexd = {
  0: '未发货',
  1: '已发货',
  2: '发货中',
  3: '已发货'
}

// 备货状态  1备货中 2配货中 3已备货
export const stockupTypeStatus = {
  1: '备货中',
  2: '配货中',
  3: '已备货'
}

// 产品发货状态 0 未发货 1 已发货
export const deliverState = {
  0: '未发货',
  1: '已发货'
}

// 产品单发货状态 0 未发货 1 已发货
export const deliverStateex = {
  0: '未发货',
  1: '发货审核',
  2: '待发货',
  3: '已发货',
  4: '审核不通过',
  5: '设置出库单'
}

// 付款方式
export const payMethodState = {
  1: '银行转账',
  2: '承兑汇票',
  3: '抵扣金额'
}

// 余额类型
export const balanceTypeState = {
  1: '不可提现余额',
  2: '可提现余额'
}
// 余额类型
export const invoiceState = {
  1: '未收票',
  2: '部门收票',
  3: '已收票'
}

// 开票类型
export const invoiceStateex = {
  0: '未开票',
  1: '开票审核',
  2: '已开票',
  3: '审核不通过',
  4: '已退票',
  5: '退票审核'
}

// 备货状态  1备货中 2配货中 3已备货
export const stockupTypeStatusex = {
  1: '备货审核',
  2: '待配货',
  3: '配货中',
  4: '备货中',
  5: '已备货'
}

// 退货状态  1退货审批 3：退货审核不通过 4.制定結算方案 5：费用结算审批 6：退貨完成 7：放弃退货
export const returnStatus = {
  1: '退货审批',
  3: '退货审核不通过',
  4: '制定結算方案',
  5: '费用结算审批',
  6: '退货完成',
  7: '放弃退货'
}
